import Api from './ApiWAService'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`whatsapp_message_template?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`whatsapp_message_template/${id}`);
    },
    create(data) {
        return Api().post(`whatsapp_message_template`, data);
    },
    update(data) {
        return Api().put(`whatsapp_message_template/${data.id}`, data);
    }
}